import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import fetchWrapper from "../../api/fetchWrapper";
import { ENDPOINT } from "../../api/endpoint";
import { getSessionData } from "../../utils/helper";

export const useGenerateSampleData = () => {
  const { selectedFilter } = useSelector((state: RootState) => state.filter);
  const userInfo = getSessionData();
  const getSampleRecordData = async (recordSampleState: any, userData: any) => {
    const body = {
      selectedRegions: selectedFilter?.selectedRegions ?? [],
      startDate: selectedFilter?.startDate,
      endDate: selectedFilter?.endDate,
      selectedCountries: selectedFilter?.selectedCountries ?? [],
      selectedAffiliates: selectedFilter?.selectedAffiliates ?? [],
      selectedProduct: selectedFilter?.selectedProduct ?? [],
      assignReviewType: recordSampleState?.assignReviewType ?? [],
      filteredSetCount: recordSampleState?.filteredSetCount,
      sampledSetCount: recordSampleState?.sampledSetCount,
      sampleId: recordSampleState?.sampleId,
      creatorEmail: userData.email,
      firstName: userData.firstName,
      lastName: userData.lastName,
      userRole:userInfo?.role,
      userId:userInfo?.userId
    };
    const response = await fetchWrapper(ENDPOINT.SAMPLE_GENERATION, {
      method: "POST",
      body: JSON.stringify(body),
    });

    return response;
  };

  return { getSampleRecordData };
};
